module.exports = __webpack_public_path__ + "img/card.a2eb7300.jpg";